import { render } from "./ProduitPosteLettre.vue?vue&type=template&id=0b74466f&scoped=true&ts=true"
import script from "./ProduitPosteLettre.vue?vue&type=script&lang=ts"
export * from "./ProduitPosteLettre.vue?vue&type=script&lang=ts"

import "./ProduitPosteLettre.vue?vue&type=style&index=0&id=0b74466f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b74466f"]])

export default __exports__